import { UserBookDurationRequest } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _UserBookDurationService {
  public storeDuration(data: UserBookDurationRequest) {
    return HttpService.post("/user/api/v2/user-book-duration", {
      body: { ...data },
      isShowLoading: false,
    });
  }
}

const UserBookDurationService = new _UserBookDurationService();

export default UserBookDurationService;
